(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-tab-block"] && !Shopify.designMode) return;
  try {
    
    class BrandsTab extends HTMLElement {
        constructor() {
            super();
            this.tabTitle = this.querySelector('.tab-title');
            this.tabContent = this.querySelector('.tab-panel-content');
            const ele = this.querySelectorAll('[tab-title-action]');
            const actionLoadMore = this.querySelectorAll('[data-load-more-block]');
            this.widthWindow = 0;
            if (ele.length) {
                ele.forEach((button) => button.addEventListener('click', this.onActive.bind(this)));
            }
            if (actionLoadMore.length) {
                actionLoadMore.forEach((button) => button.addEventListener('click', this.onLoadMore.bind(this)));
            }
        }

        onActive(e) {
            this.tabTitle.querySelector('.active').classList.remove('active');
            this.tabContent.querySelector('.active').classList.remove('active');
            this.querySelector(e.target.dataset.target).classList.add('active');
            e.target.parentElement.classList.add('active');
        }
        onLoadMore(e) {
            this.resize();
            if (this.widthWindow > 1024) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-lg');
                var _number = e.target.dataset.rowlg;
                var _class = 'hidden-lg';
                
            } else if(this.widthWindow > 551) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-md');
                var _number = 9;
                var _class = 'hidden-md';
            } else {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-sm');
                var _number = 6;
                var _class = 'hidden-sm';
            }
            if (eleHide.length) {
                // let number_show = (eleHide.length > number ? number : eleHide.length);
                if (e.target.classList.contains('more')) {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.remove('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonmore;
                    e.target.classList.remove('more');
                } else {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.add('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonless;
                    e.target.classList.add('more');
                }

                // (eleHide.length > _number ? '' : e.target.classList.add('hidden'));
            }
        }
        resize() {
            this.widthWindow = window.innerWidth;
        }
    }
    customElements.define('brand-tab', BrandsTab);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calendar-module"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('calendar-module')) return;

    var FALLBACK_MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    function daysInMonth(year, month) {
      return new Date(year, month, 0).getDate();
    }

    class CalendarModule extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';

        var parts = (this.dataset.today || '').split('-');
        this.today = { y: Number(parts[0]), m: Number(parts[1]), d: Number(parts[2]) };
        this.view = { y: this.today.y, m: this.today.m };

        var namesNode = this.querySelector('[data-calendar-month-names]');
        try {
          this.monthNames = JSON.parse(namesNode.textContent);
        } catch (error) {
          this.monthNames = FALLBACK_MONTHS;
        }

        this.trigger = this.querySelector('.calendar-module__trigger');
        this.screen = this.querySelector('.calendar-module__screen');
        this.eventsEl = this.querySelector('[data-calendar-events]');
        this.track = this.querySelector('[data-calendar-track]');
        this.fill = this.querySelector('[data-calendar-fill]');
        this.entries = Array.prototype.map.call(this.querySelectorAll('.calendar-module__event'), function (el) {
          var start = Number(el.dataset.start) || 1;
          var end = Number(el.dataset.end) || start;
          if (end < start) {
            var swap = start;
            start = end;
            end = swap;
          }
          return { el: el, month: Number(el.dataset.month), start: start, end: end };
        });

        this.develop = this.querySelector('[data-calendar-develop]');
        this.grid = this.querySelector('[data-calendar-grid]');

        this.onTrigger = this.toggle.bind(this);
        this.onClose = this.close.bind(this);
        this.onKeydown = this.handleKeydown.bind(this);
        this.onCardClick = this.handleCardClick.bind(this);
        this.onDevelopClick = this.handleDevelopClick.bind(this);

        this.trigger.addEventListener('click', this.onTrigger);
        this.querySelector('[data-calendar-close]').addEventListener('click', this.onClose);
        this.eventsEl.addEventListener('click', this.onCardClick);
        if (this.develop) this.develop.addEventListener('click', this.onDevelopClick);

        this.renderMonth();
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.onKeydown);
        document.documentElement.classList.remove('calendar-module-open');
        window.clearInterval(this.endsTimer);
        window.clearInterval(this.shineTimer);
      }

      endsLabel(entry) {
        var end = new Date(this.view.y, entry.month - 1, entry.end + 1);
        var remaining = end.getTime() - Date.now();
        if (remaining < 0) remaining = 0;
        var days = Math.floor(remaining / 86400000);
        var hours = Math.floor((remaining % 86400000) / 3600000);
        var template = this.dataset.endsIn || 'Ends in [days]d [hours]H';
        return template.replace('[days]', String(days)).replace('[hours]', String(hours));
      }

      monthName(month) {
        var name = this.monthNames[month - 1];
        if (name && String(name).trim()) return String(name).trim();
        return FALLBACK_MONTHS[month - 1];
      }

      toggle() {
        if (this.classList.contains('is-open')) this.close();
        else this.open();
      }

      open() {
        var bottom = this.trigger.getBoundingClientRect().bottom;
        this.screen.style.setProperty('--calendar-screen-top', Math.max(bottom, 0) + 'px');
        this.screen.hidden = false;
        this.classList.add('is-open');
        this.trigger.setAttribute('aria-expanded', 'true');
        this.screen.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('calendar-module-open');
        document.addEventListener('keydown', this.onKeydown);
        this.querySelector('[data-calendar-close]').focus();
        this.playFill();
        var module = this;
        window.clearInterval(this.endsTimer);
        this.endsTimer = window.setInterval(function () {
          module.renderMonth();
        }, 60000);
      }

      playFill() {
        var fill = this.fill;
        var target = (this.fillPercent || 0) + '%';
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce) {
          fill.style.width = target;
          return;
        }
        fill.classList.remove('is-filling');
        fill.style.transition = 'none';
        fill.style.width = '0%';
        void fill.offsetWidth;
        fill.style.transition = '';
        fill.classList.add('is-filling');
        fill.style.width = target;
        this.startShine();
      }

      startShine() {
        var fill = this.fill;
        window.clearInterval(this.shineTimer);
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        var seconds = Number(this.dataset.shineInterval);
        if (!seconds || seconds < 1) seconds = 4;
        this.shineTimer = window.setInterval(function () {
          fill.classList.remove('is-filling');
          void fill.offsetWidth;
          fill.classList.add('is-filling');
        }, seconds * 1000);
      }

      close() {
        if (!this.classList.contains('is-open')) return;
        this.classList.remove('is-open');
        this.screen.hidden = true;
        this.trigger.setAttribute('aria-expanded', 'false');
        this.screen.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('calendar-module-open');
        document.removeEventListener('keydown', this.onKeydown);
        window.clearInterval(this.endsTimer);
        window.clearInterval(this.shineTimer);
        if (this.fill) this.fill.classList.remove('is-filling');
        this.trigger.focus();
      }

      handleKeydown(event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          this.close();
          return;
        }
        if (event.key !== 'Tab') return;
        var items = this.screen.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        var list = [];
        for (var i = 0; i < items.length; i++) {
          if (!items[i].hidden && !items[i].disabled) list.push(items[i]);
        }
        if (!list.length) return;
        var first = list[0];
        var last = list[list.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      handleDevelopClick(event) {
        var viewButton = event.target.closest('[data-calendar-view]');
        if (viewButton) {
          this.setView(viewButton.getAttribute('data-calendar-view'));
          return;
        }
        this.handleCardClick(event);
      }

      setView(view) {
        if (!this.grid || !this.develop) return;
        var list = view === 'list';
        this.grid.classList.toggle('is-list', list);
        var buttons = this.develop.querySelectorAll('[data-calendar-view]');
        for (var i = 0; i < buttons.length; i++) {
          var active = buttons[i].getAttribute('data-calendar-view') === view;
          buttons[i].classList.toggle('is-active', active);
          buttons[i].setAttribute('aria-pressed', active ? 'true' : 'false');
        }
      }

      handleCardClick(event) {
        var link = event.target.closest('a.calendar-module__event, a.calendar-module__card-link, a.calendar-module__card-button, .calendar-module__card-title a');
        if (!link) return;
        var href = link.getAttribute('href') || '';
        if (href.charAt(0) !== '#') {
          this.close();
          return;
        }
        var target = document.getElementById(href.slice(1));
        if (!target) {
          try {
            target = document.querySelector(href);
          } catch (error) {
            target = null;
          }
        }
        if (!target) return;
        event.preventDefault();
        this.close();
        target.scrollIntoView({ block: 'start' });
      }

      renderMonth() {
        var days = daysInMonth(this.view.y, this.view.m);
        var month = this.view.m;
        var viewingNow = this.view.y === this.today.y && month === this.today.m;
        for (var i = 0; i < this.entries.length; i++) {
          var entry = this.entries[i];
          var visible = entry.month === month;
          entry.el.hidden = !visible;
          if (!visible) continue;
          var active = viewingNow && entry.start <= this.today.d && entry.end >= this.today.d;
          entry.el.classList.toggle('is-past', viewingNow && entry.end < this.today.d);
          entry.el.classList.toggle('is-now', active);
          var dates = entry.el.querySelector('.calendar-module__event-dates');
          if (!dates) continue;
          if (!dates.dataset.label) dates.dataset.label = dates.textContent;
          dates.textContent = active ? this.endsLabel(entry) : dates.dataset.label;
        }
        var percent = 0;
        if (this.view.y < this.today.y || (this.view.y === this.today.y && month < this.today.m)) percent = 100;
        else if (viewingNow) percent = Math.round((this.today.d / days) * 100);
        this.fillPercent = percent;
        this.track.setAttribute('aria-valuenow', String(percent));
        if (!this.classList.contains('is-open')) this.fill.style.width = '0%';
      }
    }

    customElements.define('calendar-module', CalendarModule);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-mobile"]) return;
  try {
    
    class StickyHeaderMobile extends HTMLElement {
        constructor() {
            super();
        }
  
        connectedCallback() {
            this.header = document.querySelector('.section-header-mobile');
            this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
            this.headerBounds = {};
    
            if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
            };
    
            this.currentScrollTop = 0;
            this.preventReveal = false;
            this.predictiveSearch = this.querySelector('predictive-search');
    
            this.onScrollHandler = this.onScroll.bind(this);
            this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    
            this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.addEventListener('scroll', this.onScrollHandler, false);
    
            this.createObserver();
        }
  
        disconnectedCallback() {
            this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.removeEventListener('scroll', this.onScrollHandler);
        }
  
        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });
    
            observer.observe(this.header);
        }
  
        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
            if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    
            if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (this.preventHide) return;
                requestAnimationFrame(this.hide.bind(this));
            } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (!this.preventReveal) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else {
                    window.clearTimeout(this.isScrolling);
        
                    this.isScrolling = setTimeout(() => {
                    this.preventReveal = false;
                    }, 66);
        
                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop <= this.headerBounds.top) {
                this.header.classList.remove('scrolled-past-header');
                requestAnimationFrame(this.reset.bind(this));
            }
    
            this.currentScrollTop = scrollTop;
        }
  
        hide() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            this.header.classList.remove('shopify-section-header-show');
            this.header.style.top = '';
        }
  
        reveal() {
            const headerMultiSite = document.querySelector('.section-header-nav-multi-site');
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            if (headerMultiSite) {
                const height = headerMultiSite.offsetHeight;
                this.header.style.top = `${height}px`;
            }
        }
  
        reset() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
            this.header.style.top = '';
        }
    }
  
    customElements.define('sticky-header-mobile', StickyHeaderMobile);

    document.querySelector('[data-mobile-menu]').addEventListener('click', () => {
        document.body.classList.toggle('menu_open');
    })

    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        const expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    };

    function renderLogoMobile() {
        if ($("[data-menu-tab]").length > 0) {

            $(document).on("click", "[data-menu-tab] li", (event) => {
                var active = $(event.currentTarget).data("load-page"),
                    href = $(event.currentTarget).attr("href");

                $.cookie("page-url", active, {
                    expires: 1,
                    path: "/",
                });
            });

            var canonical = $("[canonical-shop-url]").attr("canonical-shop-url"),
            pageUrl = $.cookie("page-url"),
            menuTabItem,
            logoTabItem,
            menuItem;

            if (
                window.location.pathname.indexOf("/pages/") !== -1 &&
                window.page_active &&
                window.page_active != pageUrl
            ) {
                setCookie("page-url", window.page_active, 1);
                pageUrl = window.page_active;
            }
            
            if (pageUrl != null) {
                menuTabItem = $(`[data-load-page="${pageUrl}"]`);
                logoTabItem = $(`[data-load-logo-page="${pageUrl}"]`);
                menuItem = $(`[data-load-menu-page="${pageUrl}"]`);
            } else {
                menuTabItem = $("[data-load-page].is-active");
                logoTabItem = $("[data-load-logo-page].first");
                menuItem = $("[data-load-menu-page].is-active");
            }

            var menuTab = menuTabItem.closest("[data-menu-tab]");

            menuTab
                .find("[data-load-page]")
                .not(menuTabItem)
                .removeClass("is-active");
                logoTabItem.siblings().removeClass("is-active");
                menuItem.siblings().removeClass("is-active");
            if (pageUrl != "") {
                logoTabItem.addClass("is-active");
                menuTabItem.addClass("is-active");
                menuItem.addClass("is-active");
            } else {
                $("[data-load-page]:nth-child(1)").addClass("is-active");
                $("[data-load-logo-page]:nth-child(1)").addClass("is-active");
                $("[data-load-menu-page]:nth-child(1)").addClass("is-active");
            }

            const header = menuTabItem.closest(".header");

            
            if (header && window.innerWidth < 1025) {
                if (
                    window.location.pathname.indexOf("/pages/") !== -1 &&
                    window.page_active &&
                    window.page_active != pageUrl
                ) {
                    setCookie("page-url", window.page_active, 1);
                    pageUrl = window.page_active;
                }

                const logoMobile = $(".header-mobile .header__heading-link");
                const logDesktop = header.find(".header__heading-link.is-active");

                if (logDesktop.data("logo-mobile") == undefined) {
                    logoMobile.find("img").addClass("logo-show");
                    return;
                } else {
                    logoMobile.html(
                    `<img src="${logDesktop.data(
                        "logo-mobile"
                    )}" alt="${logDesktop.data(
                        "logo-mobile-alt"
                    )}" style="max-width: ${logoMobile.data(
                        "logo-width"
                    )}px; height: auto"/>`
                    );

                    logoMobile.find("img").addClass("logo-show");
                    if (pageUrl != "" && pageUrl != null)
                    logoMobile.attr("href", pageUrl);
                }
            }
        }
    }

    renderLogoMobile();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-nav-multi-site"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-multi-site');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
          this.headerBounds = {};
          this.setHeaderHeight();
          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };
          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;
          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);
          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });
          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);
              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);
              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }
          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    document.addEventListener('DOMContentLoaded', () => {customElements.define('sticky-header', StickyHeader)});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-basic"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-basic');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-compact"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-compact');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-full-elements"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-full-elements');
if (sticky != undefined || sticky != null) {

    class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-hamburger"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-hamburger');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
          this.headerBounds = {};
          this.setHeaderHeight();
          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };
          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;
          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          if(this.headerIsAlwaysSticky === 'always') window.addEventListener('load', this.checkLoadPosition.bind(this));
          window.addEventListener('scroll', this.onScrollHandler, false);
          this.createObserver();
        }
        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }
        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          if(this.headerIsAlwaysSticky === 'always') window.removeEventListener('load', this.checkLoadPosition);
          window.removeEventListener('scroll', this.onScrollHandler);
        }
        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });
          observer.observe(this.header);
        }
        checkLoadPosition() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const headerGr = document.querySelectorAll(".shopify-section-group-header-group");

            if(headerGr[0].classList.contains('shopify-section-header-sticky')) {
                if(scrollTop > headerGr[0].offsetHeight && !this.header.classList.contains('scrolled-past-header')) {
                    this.header.classList.add('shopify-section-header-hidden');
                }
            } else {
                headerGr.forEach(item => {
                    if(item.classList.contains('shopify-section-header-sticky') ) {
                        const itemPrev = item.previousElementSibling;
                        const itemPrevHeight = itemPrev.offsetHeight;
                        const itemPrevTop = itemPrev.offsetTop;

                        if(scrollTop > itemPrevTop + itemPrevHeight && !this.header.classList.contains('scrolled-past-header')) {
                            this.header.classList.add('shopify-section-header-hidden');
                        }
                    }
                });
            }
        }
        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);
              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }
          this.currentScrollTop = scrollTop;
        }
        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                    document.querySelector('body').classList.add("section-header-is-hidden")
                }
            }
          this.closeMenuDisclosure();
        }
        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
                  document.querySelector('body').classList.remove("section-header-is-hidden")
              }
            }
        }
        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
                  document.querySelector('body').classList.remove("section-header-is-hidden")
              }
            }
        }
        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-left-aligned"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-left-aligned');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-plain"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-plain');

if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        document.body.classList.add('scrolled-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        document.body.classList.add('scrolled-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        document.body.classList.remove('scrolled-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-utility"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-utility');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-vertical-menu"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-vertical-menu');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
                if(!$('.vertical-menu').hasClass('vertical-menu__style_3')){
                    $('.vertical-menu').addClass('vertical-menu__hide');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
              if(!$('.vertical-menu').hasClass('vertical-menu__style_3')){
                  if (document.body.classList.contains('template-index')) {
                      if ($('.vertical-menu').hasClass('vertical-menu__hide')) {
                          $('.vertical-menu').removeClass('vertical-menu__hide');
                      }
                  }
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multi-wide-image"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('multi-wide-image-copy')) {
    function initWideImageProducts(host) {
        const root = host.querySelector('[data-wide-image-products]');
        const grid = host.querySelector('[data-wide-image-grid]');
        const dialog = host.querySelector('[data-wide-image-dialog]');
        const scroller = host.querySelector('[data-wide-image-scroller]');
        const idle = { start() {}, stop() {}, close() {}, closeFilter() {} };
        if (!root || !grid || !dialog || !scroller || root.getAttribute('data-wide-image-init') === '1') return idle;
        root.setAttribute('data-wide-image-init', '1');

        const tiles = Array.prototype.slice.call(grid.querySelectorAll('[data-block-id]'));
        const designMode = window.Shopify && window.Shopify.designMode;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const effectOn = root.getAttribute('data-effect') !== '0';
        const interval = parseInt(root.getAttribute('data-interval'), 10) || 4000;
        let timers = [];

        function frames(tile) {
            return Array.prototype.slice.call(tile.querySelectorAll('.welcome-products__frame:not(.is-filtered-out)'));
        }

        function activeTiles() {
            return tiles.filter(function (tile) {
                return !tile.classList.contains('is-filtered-out');
            });
        }

        function activeFrame(tile) {
            const active = tile.querySelector('.welcome-products__frame.is-active:not(.is-filtered-out)');
            return active || frames(tile)[0];
        }

        function ripple(tile, hold) {
            const list = frames(tile);
            if (list.length < 2 || tile.classList.contains('is-rippling')) return;
            let current = list.indexOf(activeFrame(tile));
            if (current < 0) current = 0;
            const next = list[(current + 1) % list.length];
            const ms = hold || 560;
            const nextImage = next.querySelector('img');
            if (nextImage && !nextImage.complete) {
                nextImage.addEventListener('load', function () {
                    ripple(tile, hold);
                }, { once: true });
                return;
            }
            next.style.setProperty('--welcome-reveal', ms + 'ms');
            next.classList.add('is-incoming');
            tile.classList.add('is-rippling');
            timers.push(window.setTimeout(function () {
                list.forEach(function (frame) {
                    frame.classList.remove('is-active', 'is-incoming');
                });
                next.classList.add('is-active');
                tile.classList.remove('is-rippling');
            }, ms));
        }

        if (!designMode) {
            tiles.forEach(function (tile) {
                const list = frames(tile);
                if (list.length < 2) return;
                const start = Math.floor(Math.random() * list.length);
                list.forEach(function (frame, index) {
                    frame.classList.toggle('is-active', index === start);
                });
            });
        }

        grid.classList.add('is-ready');

        function clearWaveTimers() {
            timers.forEach(function (timer) { window.clearTimeout(timer); });
            timers = [];
        }

        function stopWave() {
            window.clearTimeout(root._wideImageNext);
            clearWaveTimers();
            grid.classList.remove('is-waving');
            tiles.forEach(function (tile) {
                tile.classList.remove('is-rippling');
                frames(tile).forEach(function (frame) {
                    frame.classList.remove('is-incoming');
                });
            });
        }

        function queueNext(delay) {
            window.clearTimeout(root._wideImageNext);
            root._wideImageNext = window.setTimeout(wave, delay);
        }

        function wave() {
            if (!effectOn || host.getAttribute('data-expanded') !== 'true') return;
            if (dialog.open) {
                queueNext(700);
                return;
            }
            clearWaveTimers();
            const gridRect = grid.getBoundingClientRect();
            const span = gridRect.width + gridRect.height;
            if (span < 1) {
                queueNext(300);
                return;
            }
            const duration = Math.max(2200, Math.round(span * 3.2));
            grid.style.setProperty('--welcome-wave-duration', duration + 'ms');
            const ordered = activeTiles().sort(function (a, b) {
                const ar = a.getBoundingClientRect();
                const br = b.getBoundingClientRect();
                return (ar.top + ar.left) - (br.top + br.left);
            });
            if (!reduceMotion) {
                grid.classList.remove('is-waving');
                void grid.offsetWidth;
                grid.classList.add('is-waving');
                timers.push(window.setTimeout(function () {
                    grid.classList.remove('is-waving');
                }, duration + 40));
            }
            ordered.forEach(function (tile) {
                const rect = tile.getBoundingClientRect();
                const start = ((rect.left - gridRect.left) + (rect.top - gridRect.top)) / span;
                const cross = Math.max(280, ((rect.width + rect.height) / span) * duration);
                const delay = reduceMotion ? 0 : Math.max(0, Math.round(start * duration));
                timers.push(window.setTimeout(function () {
                    if (dialog.open || host.getAttribute('data-expanded') !== 'true') return;
                    if (reduceMotion) {
                        const list = frames(tile);
                        if (list.length < 2) return;
                        const current = list.indexOf(activeFrame(tile));
                        const next = list[(current + 1) % list.length];
                        list.forEach(function (frame) { frame.classList.remove('is-active'); });
                        next.classList.add('is-active');
                        return;
                    }
                    ripple(tile, Math.round(cross));
                }, delay));
            });
            queueNext(duration + Math.max(interval, 1200));
        }

        function whenTilesReady(done) {
            const imgs = grid.querySelectorAll('.welcome-products__frame img');
            let pending = imgs.length;
            let finished = false;
            function finish() {
                if (finished) return;
                finished = true;
                done();
            }
            if (!pending) {
                finish();
                return;
            }
            window.setTimeout(finish, 4000);
            Array.prototype.forEach.call(imgs, function (img) {
                function mark() {
                    pending -= 1;
                    if (pending <= 0) finish();
                }
                if (img.complete) mark();
                else {
                    img.addEventListener('load', mark, { once: true });
                    img.addEventListener('error', mark, { once: true });
                }
            });
        }

        function visibleCards() {
            return Array.prototype.slice.call(scroller.querySelectorAll('[data-wide-image-card]:not([hidden])'));
        }

        function cloneCard(card, placement) {
            const copy = card.cloneNode(true);
            copy.setAttribute('data-wide-image-clone', placement);
            copy.removeAttribute('hidden');
            copy.querySelectorAll('[id]').forEach(function (node) {
                node.removeAttribute('id');
            });
            return copy;
        }

        function buildLoop(blockId, finish) {
            scroller.querySelectorAll('[data-wide-image-clone]').forEach(function (node) {
                node.remove();
            });
            const cards = Array.prototype.slice.call(scroller.querySelectorAll('[data-wide-image-card]'));
            const visible = [];
            cards.forEach(function (card) {
                const show = card.getAttribute('data-block-id') === blockId && card.getAttribute('data-finish') === String(finish) && !card.hasAttribute('data-wide-image-clone');
                card.hidden = !show;
                if (show) visible.push(card);
            });
            const prevNav = host.querySelector('[data-wide-image-prev]');
            const nextNav = host.querySelector('[data-wide-image-next]');
            if (prevNav) prevNav.hidden = visible.length < 2;
            if (nextNav) nextNav.hidden = visible.length < 2;
            if (visible.length < 2) return;
            const before = document.createDocumentFragment();
            const after = document.createDocumentFragment();
            visible.forEach(function (card) {
                before.appendChild(cloneCard(card, 'before'));
                after.appendChild(cloneCard(card, 'after'));
            });
            visible[0].parentNode.insertBefore(before, visible[0]);
            visible[visible.length - 1].parentNode.insertBefore(after, visible[visible.length - 1].nextSibling);
        }

        function realCard(card) {
            if (!card || !card.hasAttribute('data-wide-image-clone')) return card;
            const kind = card.getAttribute('data-wide-image-clone');
            const copies = visibleCards().filter(function (item) {
                return item.getAttribute('data-wide-image-clone') === kind;
            });
            const reals = visibleCards().filter(function (item) {
                return !item.hasAttribute('data-wide-image-clone');
            });
            return reals[copies.indexOf(card)] || card;
        }

        function centeredCard() {
            const cards = visibleCards();
            const mid = scroller.getBoundingClientRect().left + scroller.clientWidth / 2;
            let best = null;
            let bestDistance = Infinity;
            cards.forEach(function (card) {
                const rect = card.getBoundingClientRect();
                const distance = Math.abs(rect.left + rect.width / 2 - mid);
                if (distance < bestDistance) {
                    best = card;
                    bestDistance = distance;
                }
            });
            return best;
        }

        function normalizeLoop() {
            if (!dialog.open) return;
            const current = centeredCard();
            const real = realCard(current);
            if (!current || !real || real === current) return;
            const delta = real.getBoundingClientRect().left - current.getBoundingClientRect().left;
            if (Math.abs(delta) < 2) return;
            scroller.style.scrollSnapType = 'none';
            scroller.scrollLeft += delta;
            scroller.style.scrollSnapType = '';
        }

        function showFixed(blockId, finish) {
            host.querySelectorAll('[data-wide-image-foot]').forEach(function (node) {
                node.hidden = node.getAttribute('data-block-id') !== blockId;
            });
            host.querySelectorAll('[data-wide-image-title]').forEach(function (node) {
                node.hidden = node.getAttribute('data-block-id') !== blockId || node.getAttribute('data-finish') !== String(finish);
            });
            host.querySelectorAll('[data-wide-image-meta]').forEach(function (node) {
                node.hidden = node.getAttribute('data-block-id') !== blockId || node.getAttribute('data-finish') !== String(finish);
            });
            host.querySelectorAll('[data-multi-wide-finish]').forEach(function (button) {
                const foot = button.closest('[data-wide-image-foot]');
                const on = foot && foot.getAttribute('data-block-id') === blockId && button.getAttribute('data-multi-wide-finish') === String(finish);
                button.setAttribute('aria-pressed', on ? 'true' : 'false');
            });
            const title = host.querySelector('[data-wide-image-title][data-block-id="' + blockId + '"][data-finish="' + finish + '"]');
            if (title && title.id) dialog.setAttribute('aria-labelledby', title.id);
        }

        function openDialog(blockId, slot, finish) {
            if (typeof dialog.showModal !== 'function') return;
            stopWave();
            closeFilterMenu();
            buildLoop(blockId, finish);
            showFixed(blockId, finish);
            dialog.showModal();
            window.requestAnimationFrame(function () {
                dialog.classList.add('is-shown');
                let card = scroller.querySelector('[data-block-id="' + blockId + '"][data-finish="' + finish + '"][data-slot="' + slot + '"]:not([data-wide-image-clone])');
                if (!card || card.hidden) {
                    card = scroller.querySelector('[data-block-id="' + blockId + '"][data-finish="' + finish + '"]:not([hidden]):not([data-wide-image-clone])');
                }
                if (card) card.scrollIntoView({ inline: 'center', block: 'nearest' });
            });
        }

        function closeDialog() {
            if (!dialog.open) return;
            dialog.classList.remove('is-shown');
            window.setTimeout(function () {
                if (dialog.open) dialog.close();
                if (host.getAttribute('data-expanded') === 'true') queueNext(400);
            }, 460);
        }

        grid.addEventListener('click', function (event) {
            const tile = event.target.closest('[data-block-id]');
            if (!tile || !grid.contains(tile) || tile.tagName !== 'BUTTON') return;
            const frame = activeFrame(tile);
            openDialog(
                tile.getAttribute('data-block-id'),
                frame ? frame.getAttribute('data-slot') : '1',
                frame ? frame.getAttribute('data-finish') : '1'
            );
        });

        dialog.addEventListener('cancel', function (event) {
            event.preventDefault();
            closeDialog();
        });
        dialog.addEventListener('click', function (event) {
            const finishBtn = event.target.closest('[data-multi-wide-finish]');
            if (finishBtn && dialog.contains(finishBtn)) {
                const foot = finishBtn.closest('[data-wide-image-foot]');
                if (!foot) return;
                const blockId = foot.getAttribute('data-block-id');
                const finish = finishBtn.getAttribute('data-multi-wide-finish');
                buildLoop(blockId, finish);
                showFixed(blockId, finish);
                const card = scroller.querySelector('[data-block-id="' + blockId + '"][data-finish="' + finish + '"]:not([hidden]):not([data-wide-image-clone])');
                if (card) card.scrollIntoView({ inline: 'center', block: 'nearest' });
                return;
            }
            if (event.target.closest('[data-wide-image-close]')) {
                closeDialog();
                return;
            }
            const more = event.target.closest('[data-wide-image-more]');
            if (more && dialog.contains(more)) {
                const desc = more.closest('[data-wide-image-desc]');
                if (!desc) return;
                const expanded = !desc.classList.contains('is-expanded');
                desc.classList.toggle('is-expanded', expanded);
                more.setAttribute('aria-expanded', expanded ? 'true' : 'false');
                more.textContent = expanded ? more.getAttribute('data-label-less') : more.getAttribute('data-label-more');
                return;
            }
            if (event.target === dialog) closeDialog();
        });

        function scrollByCard(direction) {
            normalizeLoop();
            const cards = visibleCards();
            const current = centeredCard();
            const index = cards.indexOf(current);
            let target = cards[index + direction];
            if (!target && cards.length) target = direction > 0 ? cards[0] : cards[cards.length - 1];
            if (!target) return;
            target.scrollIntoView({ inline: 'center', block: 'nearest', behavior: reduceMotion ? 'auto' : 'smooth' });
        }

        const prev = host.querySelector('[data-wide-image-prev]');
        const next = host.querySelector('[data-wide-image-next]');
        if (prev) prev.addEventListener('click', function () { scrollByCard(-1); });
        if (next) next.addEventListener('click', function () { scrollByCard(1); });
        let scrollTimer = 0;
        scroller.addEventListener('scroll', function () {
            window.clearTimeout(scrollTimer);
            scrollTimer = window.setTimeout(normalizeLoop, 90);
        });

        const filterRoot = host.querySelector('[data-multi-wide-filter]');
        const filterToggle = host.querySelector('[data-multi-wide-filter-toggle]');
        const filterMenu = host.querySelector('[data-multi-wide-filter-menu]');
        const filterCurrent = host.querySelector('[data-multi-wide-filter-current]');

        function closeFilterMenu() {
            if (!filterMenu || !filterToggle) return;
            filterMenu.hidden = true;
            filterToggle.setAttribute('aria-expanded', 'false');
        }

        function openFilterMenu() {
            if (!filterMenu || !filterToggle) return;
            filterMenu.hidden = false;
            filterToggle.setAttribute('aria-expanded', 'true');
        }

        function applyFilter(finish) {
            root.setAttribute('data-filter', finish);
            const option = host.querySelector('[data-multi-wide-filter-option][data-finish="' + finish + '"]');
            if (filterCurrent && option) filterCurrent.textContent = option.textContent.trim();
            host.querySelectorAll('[data-multi-wide-filter-option]').forEach(function (node) {
                node.setAttribute('aria-selected', node.getAttribute('data-finish') === finish ? 'true' : 'false');
            });
            tiles.forEach(function (tile) {
                const list = Array.prototype.slice.call(tile.querySelectorAll('.welcome-products__frame'));
                const visible = [];
                list.forEach(function (frame) {
                    const show = finish === 'mixed' || frame.getAttribute('data-finish') === finish;
                    frame.classList.toggle('is-filtered-out', !show);
                    frame.classList.remove('is-active', 'is-incoming');
                    if (show) visible.push(frame);
                });
                tile.classList.remove('is-rippling');
                if (!visible.length) {
                    tile.classList.add('is-filtered-out');
                    return;
                }
                tile.classList.remove('is-filtered-out');
                visible[0].classList.remove('is-filtered-out');
                visible[0].classList.add('is-active');
            });
            stopWave();
            if (host.getAttribute('data-expanded') === 'true') queueNext(80);
        }

        if (filterToggle && filterMenu) {
            filterToggle.addEventListener('click', function () {
                if (filterMenu.hidden) openFilterMenu();
                else closeFilterMenu();
            });
            filterMenu.addEventListener('click', function (event) {
                const option = event.target.closest('[data-multi-wide-filter-option]');
                if (!option) return;
                applyFilter(option.getAttribute('data-finish'));
                closeFilterMenu();
            });
            host.addEventListener('click', function (event) {
                if (!filterRoot || filterRoot.contains(event.target)) return;
                closeFilterMenu();
            });
            host.addEventListener('keydown', function (event) {
                if (event.key === 'Escape') closeFilterMenu();
            });
        }

        let primed = false;
        return {
            closeFilter: closeFilterMenu,
            start() {
                if (!effectOn) return;
                if (!primed) {
                    primed = true;
                    whenTilesReady(function () { queueNext(80); });
                    return;
                }
                queueNext(80);
            },
            stop: stopWave,
            close: closeDialog
        };
    }

    customElements.define('multi-wide-image-copy', class extends HTMLElement {
        connectedCallback() {
            if (this.dataset.bound === 'true') return;
            this.dataset.bound = 'true';

            const buttons = this.querySelectorAll('[data-wide-image-toggle]');
            const panel = this.querySelector('[data-wide-image-long]');
            const actions = this.querySelectorAll('.wide-image-banner__button');
            const products = initWideImageProducts(this);
            if (!buttons.length || !panel) return;

            const setExpanded = (next) => {
                this.setAttribute('data-expanded', next ? 'true' : 'false');
                buttons.forEach((button) => {
                    button.setAttribute('aria-expanded', next ? 'true' : 'false');
                });
                if (next) {
                    panel.removeAttribute('hidden');
                    products.start();
                } else {
                    products.close();
                    products.stop();
                    products.closeFilter();
                    panel.setAttribute('hidden', '');
                }
                actions.forEach((action) => {
                    if (next) {
                        action.removeAttribute('aria-hidden');
                        if (action.tagName === 'A') action.removeAttribute('tabindex');
                    } else {
                        action.setAttribute('aria-hidden', 'true');
                        if (action.tagName === 'A') action.setAttribute('tabindex', '-1');
                    }
                });
            };

            buttons.forEach((button) => {
                button.addEventListener('click', () => {
                    setExpanded(this.getAttribute('data-expanded') !== 'true');
                });
            });
        }
    });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wide-image"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('wide-image-copy')) {
    function initWideImageProducts(host) {
        const root = host.querySelector('[data-wide-image-products]');
        const grid = host.querySelector('[data-wide-image-grid]');
        const dialog = host.querySelector('[data-wide-image-dialog]');
        const scroller = host.querySelector('[data-wide-image-scroller]');
        const idle = { start() {}, stop() {}, close() {} };
        if (!root || !grid || !dialog || !scroller || root.getAttribute('data-wide-image-init') === '1') return idle;
        root.setAttribute('data-wide-image-init', '1');

        const tiles = Array.prototype.slice.call(grid.querySelectorAll('[data-block-id]'));
        const designMode = window.Shopify && window.Shopify.designMode;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const effectOn = root.getAttribute('data-effect') !== '0';
        const interval = parseInt(root.getAttribute('data-interval'), 10) || 4000;
        let timers = [];

        function frames(tile) {
            return Array.prototype.slice.call(tile.querySelectorAll('.welcome-products__frame'));
        }

        function activeFrame(tile) {
            return tile.querySelector('.welcome-products__frame.is-active') || frames(tile)[0];
        }

        function ripple(tile, hold) {
            const list = frames(tile);
            if (list.length < 2 || tile.classList.contains('is-rippling')) return;
            let current = list.indexOf(activeFrame(tile));
            if (current < 0) current = 0;
            const next = list[(current + 1) % list.length];
            const ms = hold || 560;
            const nextImage = next.querySelector('img');
            if (nextImage && !nextImage.complete) {
                nextImage.addEventListener('load', function () {
                    ripple(tile, hold);
                }, { once: true });
                return;
            }
            next.style.setProperty('--welcome-reveal', ms + 'ms');
            next.classList.add('is-incoming');
            tile.classList.add('is-rippling');
            timers.push(window.setTimeout(function () {
                list.forEach(function (frame) {
                    frame.classList.remove('is-active', 'is-incoming');
                });
                next.classList.add('is-active');
                tile.classList.remove('is-rippling');
            }, ms));
        }

        if (!designMode) {
            tiles.forEach(function (tile) {
                const list = frames(tile);
                if (list.length < 2) return;
                const start = Math.floor(Math.random() * list.length);
                list.forEach(function (frame, index) {
                    frame.classList.toggle('is-active', index === start);
                });
            });
        }

        grid.classList.add('is-ready');

        function clearWaveTimers() {
            timers.forEach(function (timer) { window.clearTimeout(timer); });
            timers = [];
        }

        function stopWave() {
            window.clearTimeout(root._wideImageNext);
            clearWaveTimers();
            grid.classList.remove('is-waving');
            tiles.forEach(function (tile) {
                tile.classList.remove('is-rippling');
                frames(tile).forEach(function (frame) {
                    frame.classList.remove('is-incoming');
                });
            });
        }

        function queueNext(delay) {
            window.clearTimeout(root._wideImageNext);
            root._wideImageNext = window.setTimeout(wave, delay);
        }

        function wave() {
            if (!effectOn || host.getAttribute('data-expanded') !== 'true') return;
            if (dialog.open) {
                queueNext(700);
                return;
            }
            clearWaveTimers();
            const gridRect = grid.getBoundingClientRect();
            const span = gridRect.width + gridRect.height;
            if (span < 1) {
                queueNext(300);
                return;
            }
            const duration = Math.max(2200, Math.round(span * 3.2));
            grid.style.setProperty('--welcome-wave-duration', duration + 'ms');
            const ordered = tiles.slice().sort(function (a, b) {
                const ar = a.getBoundingClientRect();
                const br = b.getBoundingClientRect();
                return (ar.top + ar.left) - (br.top + br.left);
            });
            if (!reduceMotion) {
                grid.classList.remove('is-waving');
                void grid.offsetWidth;
                grid.classList.add('is-waving');
                timers.push(window.setTimeout(function () {
                    grid.classList.remove('is-waving');
                }, duration + 40));
            }
            ordered.forEach(function (tile) {
                const rect = tile.getBoundingClientRect();
                const start = ((rect.left - gridRect.left) + (rect.top - gridRect.top)) / span;
                const cross = Math.max(280, ((rect.width + rect.height) / span) * duration);
                const delay = reduceMotion ? 0 : Math.max(0, Math.round(start * duration));
                timers.push(window.setTimeout(function () {
                    if (dialog.open || host.getAttribute('data-expanded') !== 'true') return;
                    if (reduceMotion) {
                        const list = frames(tile);
                        if (list.length < 2) return;
                        const current = list.indexOf(activeFrame(tile));
                        const next = list[(current + 1) % list.length];
                        list.forEach(function (frame) { frame.classList.remove('is-active'); });
                        next.classList.add('is-active');
                        return;
                    }
                    ripple(tile, Math.round(cross));
                }, delay));
            });
            queueNext(duration + Math.max(interval, 1200));
        }

        function whenTilesReady(done) {
            const imgs = grid.querySelectorAll('.welcome-products__frame img');
            let pending = imgs.length;
            let finished = false;
            function finish() {
                if (finished) return;
                finished = true;
                done();
            }
            if (!pending) {
                finish();
                return;
            }
            window.setTimeout(finish, 4000);
            Array.prototype.forEach.call(imgs, function (img) {
                function mark() {
                    pending -= 1;
                    if (pending <= 0) finish();
                }
                if (img.complete) mark();
                else {
                    img.addEventListener('load', mark, { once: true });
                    img.addEventListener('error', mark, { once: true });
                }
            });
        }

        function visibleCards() {
            return Array.prototype.slice.call(scroller.querySelectorAll('[data-wide-image-card]:not([hidden])'));
        }

        function cloneCard(card, placement) {
            const copy = card.cloneNode(true);
            copy.setAttribute('data-wide-image-clone', placement);
            copy.removeAttribute('hidden');
            copy.querySelectorAll('[id]').forEach(function (node) {
                node.removeAttribute('id');
            });
            return copy;
        }

        function buildLoop(blockId) {
            scroller.querySelectorAll('[data-wide-image-clone]').forEach(function (node) {
                node.remove();
            });
            const cards = Array.prototype.slice.call(scroller.querySelectorAll('[data-wide-image-card]'));
            const visible = [];
            cards.forEach(function (card) {
                const show = card.getAttribute('data-block-id') === blockId && !card.hasAttribute('data-wide-image-clone');
                card.hidden = !show;
                if (show) visible.push(card);
            });
            const prevNav = host.querySelector('[data-wide-image-prev]');
            const nextNav = host.querySelector('[data-wide-image-next]');
            if (prevNav) prevNav.hidden = visible.length < 2;
            if (nextNav) nextNav.hidden = visible.length < 2;
            if (visible.length < 2) return;
            const before = document.createDocumentFragment();
            const after = document.createDocumentFragment();
            visible.forEach(function (card) {
                before.appendChild(cloneCard(card, 'before'));
                after.appendChild(cloneCard(card, 'after'));
            });
            visible[0].parentNode.insertBefore(before, visible[0]);
            visible[visible.length - 1].parentNode.insertBefore(after, visible[visible.length - 1].nextSibling);
        }

        function realCard(card) {
            if (!card || !card.hasAttribute('data-wide-image-clone')) return card;
            const kind = card.getAttribute('data-wide-image-clone');
            const copies = visibleCards().filter(function (item) {
                return item.getAttribute('data-wide-image-clone') === kind;
            });
            const reals = visibleCards().filter(function (item) {
                return !item.hasAttribute('data-wide-image-clone');
            });
            return reals[copies.indexOf(card)] || card;
        }

        function centeredCard() {
            const cards = visibleCards();
            const mid = scroller.getBoundingClientRect().left + scroller.clientWidth / 2;
            let best = null;
            let bestDistance = Infinity;
            cards.forEach(function (card) {
                const rect = card.getBoundingClientRect();
                const distance = Math.abs(rect.left + rect.width / 2 - mid);
                if (distance < bestDistance) {
                    best = card;
                    bestDistance = distance;
                }
            });
            return best;
        }

        function normalizeLoop() {
            if (!dialog.open) return;
            const current = centeredCard();
            const real = realCard(current);
            if (!current || !real || real === current) return;
            const delta = real.getBoundingClientRect().left - current.getBoundingClientRect().left;
            if (Math.abs(delta) < 2) return;
            scroller.style.scrollSnapType = 'none';
            scroller.scrollLeft += delta;
            scroller.style.scrollSnapType = '';
        }

        function showFixed(blockId) {
            host.querySelectorAll('[data-wide-image-title]').forEach(function (node) {
                node.hidden = node.getAttribute('data-block-id') !== blockId;
            });
            host.querySelectorAll('[data-wide-image-meta]').forEach(function (node) {
                node.hidden = node.getAttribute('data-block-id') !== blockId;
            });
            const title = host.querySelector('[data-wide-image-title][data-block-id="' + blockId + '"]');
            if (title && title.id) dialog.setAttribute('aria-labelledby', title.id);
        }

        function openDialog(blockId, slot) {
            if (typeof dialog.showModal !== 'function') return;
            stopWave();
            buildLoop(blockId);
            showFixed(blockId);
            dialog.showModal();
            window.requestAnimationFrame(function () {
                dialog.classList.add('is-shown');
                let card = scroller.querySelector('[data-block-id="' + blockId + '"][data-slot="' + slot + '"]:not([data-wide-image-clone])');
                if (!card || card.hidden) {
                    card = scroller.querySelector('[data-block-id="' + blockId + '"]:not([hidden]):not([data-wide-image-clone])');
                }
                if (card) card.scrollIntoView({ inline: 'center', block: 'nearest' });
            });
        }

        function closeDialog() {
            if (!dialog.open) return;
            dialog.classList.remove('is-shown');
            window.setTimeout(function () {
                if (dialog.open) dialog.close();
                if (host.getAttribute('data-expanded') === 'true') queueNext(400);
            }, 460);
        }

        grid.addEventListener('click', function (event) {
            const tile = event.target.closest('[data-block-id]');
            if (!tile || !grid.contains(tile) || tile.tagName !== 'BUTTON') return;
            const frame = activeFrame(tile);
            openDialog(tile.getAttribute('data-block-id'), frame ? frame.getAttribute('data-slot') : '1');
        });

        dialog.addEventListener('cancel', function (event) {
            event.preventDefault();
            closeDialog();
        });
        dialog.addEventListener('click', function (event) {
            if (event.target.closest('[data-wide-image-close]')) {
                closeDialog();
                return;
            }
            const more = event.target.closest('[data-wide-image-more]');
            if (more && dialog.contains(more)) {
                const desc = more.closest('[data-wide-image-desc]');
                if (!desc) return;
                const expanded = !desc.classList.contains('is-expanded');
                desc.classList.toggle('is-expanded', expanded);
                more.setAttribute('aria-expanded', expanded ? 'true' : 'false');
                more.textContent = expanded ? more.getAttribute('data-label-less') : more.getAttribute('data-label-more');
                return;
            }
            if (event.target === dialog) closeDialog();
        });

        function scrollByCard(direction) {
            normalizeLoop();
            const cards = visibleCards();
            const current = centeredCard();
            const index = cards.indexOf(current);
            let target = cards[index + direction];
            if (!target && cards.length) target = direction > 0 ? cards[0] : cards[cards.length - 1];
            if (!target) return;
            target.scrollIntoView({ inline: 'center', block: 'nearest', behavior: reduceMotion ? 'auto' : 'smooth' });
        }

        const prev = host.querySelector('[data-wide-image-prev]');
        const next = host.querySelector('[data-wide-image-next]');
        if (prev) prev.addEventListener('click', function () { scrollByCard(-1); });
        if (next) next.addEventListener('click', function () { scrollByCard(1); });
        let scrollTimer = 0;
        scroller.addEventListener('scroll', function () {
            window.clearTimeout(scrollTimer);
            scrollTimer = window.setTimeout(normalizeLoop, 90);
        });

        let primed = false;
        return {
            start() {
                if (!effectOn) return;
                if (!primed) {
                    primed = true;
                    whenTilesReady(function () { queueNext(80); });
                    return;
                }
                queueNext(80);
            },
            stop: stopWave,
            close: closeDialog
        };
    }

    customElements.define('wide-image-copy', class extends HTMLElement {
        connectedCallback() {
            if (this.dataset.bound === 'true') return;
            this.dataset.bound = 'true';

            const buttons = this.querySelectorAll('[data-wide-image-toggle]');
            const panel = this.querySelector('[data-wide-image-long]');
            const actions = this.querySelectorAll('.wide-image-banner__button');
            const products = initWideImageProducts(this);
            if (!buttons.length || !panel) return;

            const setExpanded = (next) => {
                this.setAttribute('data-expanded', next ? 'true' : 'false');
                buttons.forEach((button) => {
                    button.setAttribute('aria-expanded', next ? 'true' : 'false');
                });
                if (next) {
                    panel.removeAttribute('hidden');
                    products.start();
                } else {
                    products.close();
                    products.stop();
                    panel.setAttribute('hidden', '');
                }
                actions.forEach((action) => {
                    if (next) {
                        action.removeAttribute('aria-hidden');
                        if (action.tagName === 'A') action.removeAttribute('tabindex');
                    } else {
                        action.setAttribute('aria-hidden', 'true');
                        if (action.tagName === 'A') action.setAttribute('tabindex', '-1');
                    }
                });
            };

            buttons.forEach((button) => {
                button.addEventListener('click', () => {
                    setExpanded(this.getAttribute('data-expanded') !== 'true');
                });
            });
        }
    });
}

  } catch(e) { console.error(e); }
})();
})();
